<script>
import Multiselect from 'vue-multiselect';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  props: {
    itemId: { type: Number, required: true },
    allocationId: { type: Number },
    repository: { type: Object, required: true },
  },
  components: {
    Multiselect,
    Loading,
  },
  data() {
    return {
      allocationGroups: [],
      allocation: null,
      isLoading: false,
      firstLoadDone: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        this.isLoading = true;

        let resp =
          await this.repository.customREST.getAllocationGroupsWithAllocations(
            this.itemId
          );

        this.allocationGroups = resp.data.data;

        let allocation = this.allocations.find((x) => {
          return x.id == this.allocationId;
        });

        this.allocation = allocation;
      } catch {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
      } finally {
        this.$nextTick(() => {
          this.isLoading = false;
          this.firstLoadDone = true;
        });
      }
    },
    async allocationSelectionChanged() {
      try {
        this.isLoading = true;

        let patchPayload = [
          {
            op: 'add',
            path: 'allocationId',
            value: this.allocation?.id,
          },
          {
            op: 'add',
            path: 'allocationIdPublic',
            value: this.allocation?.idPublic,
          },
        ];
        await this.repository.customREST.patchItem(this.itemId, patchPayload);

        this.$toast.successToast(this.$t('general.success'));
      } catch {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
      } finally {
        this.isLoading = false;
      }
    },
    clearMultiSelect() {
      this.allocation = null;
    },
  },
  computed: {
    allocations() {
      if (this.allocationGroups == null || this.allocationGroups.length == 0)
        return [];

      return this.allocationGroups.flatMap(({ allocations }) => allocations);
    },
  },
  watch: {
    allocation() {
      if (!this.firstLoadDone) return;

      this.allocationSelectionChanged();
    },
  },
};
</script>

<template>
  <div class="allocation-edition">
    <loading
      :active="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="true"
    >
    </loading>

    <b-form-group
      class="allocation-groups-group"
      :label="`${$t('allocations.allocation')}`"
    >
      <multiselect
        class="no_overflow"
        v-model="allocation"
        :searchable="true"
        :options="allocationGroups"
        :multiple="false"
        label="name"
        group-label="name"
        group-values="allocations"
        :show-labels="false"
        :placeholder="$t('allocations.allocation')"
      >
        <template v-slot:noOptions>
          {{ $t('general.noResult') }}
        </template>

        <template slot="singleLabel" slot-scope="{ option }">
          <div class="flex-box">
            <div>{{ option.name }}</div>
            <div
              class="flex-push"
              style="padding-left: 10px; padding-right: 5px; cursor: pointer"
              @mousedown.prevent.stop="clearMultiSelect()"
            >
              <i class="fas fa-times text-secondary"></i>
            </div>
          </div>
        </template>
      </multiselect>
    </b-form-group>
  </div>
</template>

<style>
.no_overflow .multiselect__content-wrapper {
  max-width: 100%;
  border-top: 1px solid #e8e8e8;
}

.multiselect--active .multiselect__tags {
  border-bottom: none;
}
</style>

<style scoped>
.allocation-edition {
  width: min(300px, 80vw + 20px);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.allocation-groups-group {
  width: 100%;
  margin-bottom: 30px;
}
</style>